<template>
  <div class="merchantInfo ">
    <h2 class="intro-y text-lg font-medium mt-10">一键转至360pai进行租赁权招商</h2>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div
          class="intro-y col-span-12 flex flex-wrap sm:flex-no-wrap items-center mt-2"
      >
        <button class="button text-white bg-theme-1 shadow-md mr-2"
                @click='$router.push({path:"/assetManagement/assetDetail",query:{ assetId :  form.assetId}})'>
          返回
        </button>
      </div>
    </div>
    <div class="intro-y box py-10 sm:py-20 mt-5">
      <div
          class="wizard flex flex-col lg:flex-row justify-center px-5 sm:px-20"
      >
        <div
            class="intro-x lg:text-center flex items-center lg:block flex-1 z-10"
        >
          <button class="w-10 h-10 rounded-full button text-gray-600 bg-gray-200 dark:bg-dark-1">
            1
          </button>
          <div class="lg:w-32 font-medium text-base lg:mt-3 ml-3 lg:mx-auto">
            生成招商公告
          </div>
        </div>

        <div
            class="intro-x lg:text-center flex items-center mt-5 lg:mt-0 lg:block flex-1 z-10"
        >
          <button
              class="w-10 h-10 rounded-full button text-white bg-theme-1"
          >
            2
          </button>
          <div
              class="lg:w-32 text-base lg:mt-3 ml-3 lg:mx-auto text-gray-700 dark:text-gray-600"
          >
            填写拍卖信息
          </div>
        </div>
        <div
            class="intro-x lg:text-center flex items-center mt-5 lg:mt-0 lg:block flex-1 z-10"
        >
          <button
              class="w-10 h-10 rounded-full button text-gray-600 bg-gray-200 dark:bg-dark-1"

          >
            3
          </button>
          <div
              class="lg:w-32 text-base lg:mt-3 ml-3 lg:mx-auto text-gray-700 dark:text-gray-600"
          >
            完成
          </div>
        </div>
        <div
            class="wizard__line hidden lg:block w-1/2 bg-gray-200 dark:bg-dark-1 absolute mt-5"
        ></div>
      </div>
      <div class="px-5 sm:px-20 mt-10 pt-10 border-t border-gray-200 dark:border-dark-5">
        <el-form
            ref="ruleForm"
            :model="form"
            layout='horizontal'
            :rules="rules"
            style='width: 100%;'
        >
          <el-row :span='24'>
            <el-col :span='11' :offset='1'>
              <el-form-item label="招商价格: " prop="enrollingPrice">
                <el-col>
                  <el-input v-model="form.enrollingPrice" placeholder="请输入招商价格" allowClear style='width: 60%'/>
                  <el-select v-model="unitFlag" style='width: 35%;margin-left: 5%;'>
                    <el-option
                        :value="item.id"
                        :label="item.name"
                        v-for="(item,index) in unitOptions"
                        :key='item.id'>
                      {{ item.name }}
                    </el-option>
                  </el-select>
                </el-col>

                <div class="right-money">
                  {{ enrollingPriceUnitChange }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="平台服务费金额: ">
                <el-input value='首年首月租金' disabled/>
              </el-form-item>
            </el-col>
            <el-col :span='11' :offset='1'>
              <el-form-item label="租赁起止期限约定: " prop='leaseTime'>
                <el-date-picker
                    style='width: 100%'
                    :value-format="dateFormat"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    v-model="form.time"
                    :default-time="['00:00:00', '23:59:59']"
                    clearable/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="intro-y col-span-12 flex items-center justify-center sm:justify-end mt-5"
           style='padding-right: 5rem;'>
        <el-button type="primary" @click='handleSubmit' :loading='loading' style='width: 127px' size='large'>
          提交发布
        </el-button>
        <el-button @click='back' style='margin-left: 50px;' size='large'>
          返回
        </el-button>
      </div>
    </div>

  </div>
</template>

<script>
import {mapState} from 'vuex'
import {saveEnrolling} from "../../../../api/asset";

export default {
  name: "merchantInfo",
  components: {},
  data() {
    let checkNumber = (rule, value, callback) => {
      let numberReg = /^[0-9]{1}\d*(\.\d{1,2})?$/
      if (numberReg.test(value)) {
        callback()
      } else {
        callback(new Error(rule.message));
      }
    };
    return {
      current: 1,
      unitFlag: 1,
      loading: false,
      rules: {
        enrollingPrice: [
          {required: true, message: '请输入招商价格（最多两位小数）', validator: checkNumber, trigger: 'blur'},
        ],
      },
    }
  },
  methods: {
    handleSubmit() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          let para = Object.assign({}, this.form)
          console.log(para.areaArray)
          let areaArray = []
          for (let i = 0; i < para.areaArray.length; i++) {
            areaArray.push({
              provinceId: para.areaArray[i][0] || '',
              id: para.areaArray[i][1] || '',
              areaId: para.areaArray[i][2] || '',
              townId: para.areaArray[i][3] || '',
            })
          }
          para.areaArray = areaArray
          para.viewBeginTime = para.viewTime[0] || ''
          para.viewEndTime = para.viewTime[1] || ''
          para.beginAt = para.time[0] || ''
          para.endAt = para.time[1] || ''
          para.stepStatus = '3'
          saveEnrolling(para).then(res => {
            let data = res.data
            if (data.code === '000') {
              this.$store.dispatch('setMerchantForm', para)
              this.$router.push({path: '/assetManagement/merchantSuccess', query: {assetId: para.assetId}})
            } else if (data.code == 1) {
              const h = this.$createElement;
              this.$msgbox({
                title: '温馨提示',
                message: h('p', null, [
                  h('span', {style: 'color: red'}, '未在360pai中找到对应的公司信息'),
                  h('span', null, '，请先在360pai注册该企业。 '),
                ]),
                showCancelButton: true,
                confirmButtonText: '前往360pai',
                cancelButtonText: '取消',
              }).then(action => {
                window.open('https://www.360pai.com/member/profile')
              });
            } else if (data.code == 2) {
              const h = this.$createElement;
              this.$msgbox({
                title: '温馨提示',
                message: h('p', null, [
                  h('span', {style: 'color: red'}, '未在360pai该公司下找到对应的企业经办人'),
                  h('span', null, '，请联系400-015-0005新增经办人。 '),
                ]),
                showCancelButton: true,
                confirmButtonText: '前往360pai',
                cancelButtonText: '取消',
              }).then(action => {
                window.open('https://www.360pai.com/member/profile')
              });
            } else {
              this.$message.error(data.desc)
            }
          }).catch(err => {
            console.log(err);
          }).finally(() => {
            this.loading = false
          })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    back() {
      this.$router.push({path: '/assetManagement/assetDetail', query: {assetId: this.form.assetId}})
    },
    changeTime(value, dateString) {
      this.form.time = dateString
    },
  },
  computed: {
    ...mapState({
      expectedModeOptions: state => state.public.expectedModeOptions,
      unitOptions: state => state.public.unitOptions,
      dateFormat: state => state.public.dateFormat,
      form: state => state.merchant.form,
    }),

    //起拍价单位转换
    enrollingPriceUnitChange() {
      if (this.form.enrollingPrice && this.form.leaseArea) {
        if (this.unitFlag == 1) {
          return (this.form.enrollingPrice / 365 / this.form.leaseArea).toFixed(2) + '元/平米/日'
        } else {
          return this.form.enrollingPrice * 365 * this.form.leaseArea + '元/年'
        }
      } else {
        if (this.unitFlag == 1) {
          return ''
        } else {
          return ''
        }
      }
    },
  },
  filters: {
    twoFilter: function (value) {
      return value.toFixed(2)
    }
  },
  created() {

  }
}
</script>

<style>
.merchantInfo .ant-calendar-picker {
  width: 100%;
}

#times .ant-calendar-picker {
  min-width: initial !important;
}
</style>
<style scoped lang="scss">
.merchantInfo {


  .right-link {
    text-decoration: underline;
    color: #1d4299;
    font-size: 16px;
    padding-left: 20px;
    white-space: nowrap;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
  }

  .right-money {
    color: #333;
    font-size: 14px;
    padding-left: 20px;
    white-space: nowrap;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
  }

  .unit {
    position: absolute;
    bottom: 12px;
    right: -20px;
    line-height: 1;
    white-space: nowrap;
  }

  h3 {
    font-size: 30px;
    font-weight: 700;
    margin: 20px 0;
    text-align: center;
  }

}
</style>
